import React, { Fragment, useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import HeaderEjercicios from '../../../AuxiliaresPaginas/HeaderEjercicios';
import Instrucciones from '../../../Escritorio/Instrucciones';

import useConfigAuth from '../../../../Hooks/useConfigAuth';

import BotoneraBottom from '../../Compartidos/BotoneraBottom';

import {
    finalizarEjercicioAction,
    setearEjercicioAction,
    setearUrlAnteriorAction
} from '../../../../actions/estadoEjercicioActions';

import { almacenarAction } from '../../../../actions/almacenarEjercicioActions';

import { ContainerFlex } from '../../../Css/MetodosCSS/StyledLN2Todos';

import {
    AvanzarImg,
    AvanzarBtn,
    PantallaM157,
    ContenidoM157,
    ZonaTrabajoM157,
    EjemploM157,
    ActividadM157,
    EscenaM157,
    BottomM157
} from '../../../Css/StyledMatematica';


// ============================================================================
// CONFIGURACIÓN
// ============================================================================

const CANTIDAD_EJERCICIOS = 3;

const ACCENT = '#23AAAF';
const MARK = '#E8662B';
const OK = '#2E8B57';
const INK = '#222222';

const TIRA = [
    '#F2A541',
    '#F8C97A'
];


const miniInstrucciones =
    'Completá el entero, escribilo como fracción y representalo en la recta numérica.';


// ============================================================================
// EJERCICIOS
// ============================================================================

const EJERCICIOS = [

    {
        tipo: 'pizza',
        n: 4
    },

    {
        tipo: 'chocolate',
        n: 2
    },

    {
        tipo: 'pizza',
        n: 8
    },

    {
        tipo: 'chocolate',
        n: 3
    },

    {
        tipo: 'pizza',
        n: 6
    },

    {
        tipo: 'chocolate',
        n: 4
    },

    {
        tipo: 'pizza',
        n: 3
    },

    {
        tipo: 'chocolate',
        n: 6
    },

    {
        tipo: 'pizza',
        n: 2
    },

    {
        tipo: 'chocolate',
        n: 5
    }

];


const NOMBRE = {

    pizza:
        'la pizza',

    chocolate:
        'el chocolate'
};


// ============================================================================
// AUXILIARES
// ============================================================================

const range = (
    cantidad
) => {

    return Array.from(
        {
            length: cantidad
        },
        (_, index) => index
    );
};


const mezclar = (
    array
) => {

    const copia = [
        ...array
    ];


    for (
        let i = copia.length - 1;
        i > 0;
        i--
    ) {

        const j =
            Math.floor(
                Math.random() *
                (
                    i + 1
                )
            );


        [
            copia[i],
            copia[j]
        ] = [
            copia[j],
            copia[i]
        ];
    }


    return copia;
};


// ============================================================================
// SELECCIÓN
//
// Garantizamos pizza + chocolate.
// ============================================================================

const seleccionarEjercicios = () => {

    const pizzas =
        mezclar(
            EJERCICIOS.filter(
                item =>
                    item.tipo ===
                    'pizza'
            )
        );


    const chocolates =
        mezclar(
            EJERCICIOS.filter(
                item =>
                    item.tipo ===
                    'chocolate'
            )
        );


    const seleccion = [

        pizzas[0],

        chocolates[0]

    ];


    const usados =
        new Set(
            seleccion.map(
                item =>
                    `${item.tipo}-${item.n}`
            )
        );


    const restantes =
        mezclar(
            EJERCICIOS.filter(
                item =>

                    !usados.has(
                        `${item.tipo}-${item.n}`
                    )
            )
        );


    while (
        seleccion.length <
        CANTIDAD_EJERCICIOS &&
        restantes.length >
        0
    ) {

        seleccion.push(
            restantes.shift()
        );
    }


    return mezclar(
        seleccion
    );
};


// ============================================================================
// SECTOR
// ============================================================================

const sector = (
    cx,
    cy,
    r,
    a0,
    a1
) => {

    if (
        a1 -
        a0 >=
        359.99
    ) {

        return (
            `M${cx - r} ${cy}
             A${r} ${r} 0 1 1 ${cx + r} ${cy}
             A${r} ${r} 0 1 1 ${cx - r} ${cy} Z`
        );
    }


    const punto = (
        angulo
    ) => [

        cx +
        r *
        Math.sin(
            (
                angulo *
                Math.PI
            ) /
            180
        ),

        cy -
        r *
        Math.cos(
            (
                angulo *
                Math.PI
            ) /
            180
        )
    ];


    const [
        x0,
        y0
    ] = punto(
        a0
    );


    const [
        x1,
        y1
    ] = punto(
        a1
    );


    const large =
        a1 -
        a0 >
        180

            ? 1
            : 0;


    return (
        `M${cx} ${cy}
         L${x0} ${y0}
         A${r} ${r} 0 ${large} 1 ${x1} ${y1}
         Z`
    );
};


// ============================================================================
// PORCIÓN DE PIZZA
// ============================================================================

const Porcion = ({
    cx,
    cy,
    a0,
    a1
}) => {

    const am =
        (
            (
                a0 +
                a1
            ) /
            2
        ) *
        Math.PI /
        180;


    const olivas =
        [
            0.45,
            0.75
        ]
            .map(
                (
                    factor,
                    index
                ) => {

                    const da =
                        (
                            a1 -
                            a0
                        ) *
                        (
                            index === 0
                                ? -0.15
                                : 0.15
                        ) *
                        Math.PI /
                        180;


                    return [

                        cx +
                        128 *
                        factor *
                        Math.sin(
                            am +
                            da
                        ),

                        cy -
                        128 *
                        factor *
                        Math.cos(
                            am +
                            da
                        )

                    ];
                }
            );


    return (

        <g>

            <path
                d={
                    sector(
                        cx,
                        cy,
                        128,
                        a0,
                        a1
                    )
                }
                fill="#D99A4E"
                stroke="#FFFFFF"
                strokeWidth={
                    4
                }
                strokeLinejoin="round"
            />


            <path
                d={
                    sector(
                        cx,
                        cy,
                        112,
                        a0 + 1,
                        a1 - 1
                    )
                }
                fill="#F7D774"
            />


            {
                olivas.map(
                    (
                        [
                            x,
                            y
                        ],
                        index
                    ) => (

                        <g
                            key={
                                index
                            }
                        >

                            <circle
                                cx={
                                    x
                                }
                                cy={
                                    y
                                }
                                r={
                                    7
                                }
                                fill={
                                    index === 0
                                        ? '#2E3B1F'
                                        : '#D9442B'
                                }
                            />


                            {
                                index === 0 && (

                                    <circle
                                        cx={
                                            x
                                        }
                                        cy={
                                            y
                                        }
                                        r={
                                            2.5
                                        }
                                        fill="#7A8A55"
                                    />
                                )
                            }

                        </g>
                    )
                )
            }

        </g>
    );
};


// ============================================================================
// PIZZA ENTERA
// ============================================================================

const PizzaEntera = ({
    n,
    puestos,
    size = 300
}) => {

    const paso =
        360 /
        n;


    return (

        <svg
            viewBox="0 0 300 300"
            style={{
                width:
                    size,

                maxWidth:
                    '100%',

                height:
                    'auto',

                display:
                    'block'
            }}
            role="img"
            aria-label="Pizza para completar"
        >

            <circle
                cx={
                    150
                }
                cy={
                    150
                }
                r={
                    142
                }
                fill="#FFFFFF"
                stroke="#CFCFCF"
                strokeWidth={
                    3
                }
            />


            <circle
                cx={
                    150
                }
                cy={
                    150
                }
                r={
                    128
                }
                fill="none"
                stroke="#9E9E9E"
                strokeWidth={
                    2.5
                }
                strokeDasharray="8 7"
            />


            {
                range(
                    puestos
                )
                    .map(
                        index => (

                            <Porcion
                                key={
                                    index
                                }
                                cx={
                                    150
                                }
                                cy={
                                    150
                                }
                                a0={
                                    index *
                                    paso
                                }
                                a1={
                                    (
                                        index +
                                        1
                                    ) *
                                    paso
                                }
                            />
                        )
                    )
            }

        </svg>
    );
};


// ============================================================================
// PEDAZO DE PIZZA
// ============================================================================

const PizzaPedazo = ({
    n,
    alto = 150
}) => {

    const paso =
        360 /
        n;


    const medio =
        Math.min(
            90,
            paso /
            2
        );


    const width =
        2 *
        128 *
        Math.sin(
            (
                medio *
                Math.PI
            ) /
            180
        );


    const viewBox =
        `${150 - width / 2 - 8} ${150 - 128 - 8} ${width + 16} ${128 + 16}`;


    return (

        <svg
            viewBox={
                viewBox
            }
            style={{
                height:
                    alto,

                width:
                    'auto',

                maxWidth:
                    250,

                display:
                    'block'
            }}
            role="img"
            aria-label="Un pedazo de pizza"
        >

            <Porcion
                cx={
                    150
                }
                cy={
                    150
                }
                a0={
                    -paso /
                    2
                }
                a1={
                    paso /
                    2
                }
            />

        </svg>
    );
};


// ============================================================================
// CHOCOLATE
// ============================================================================

const ColumnaChocolate = ({
    x,
    y,
    w,
    h
}) => {

    const rows =
        3;


    const cols =
        Math.max(
            1,
            Math.round(
                w /
                46
            )
        );


    const cw =
        w /
        cols;


    const ch =
        h /
        rows;


    return (

        <g>

            <rect
                x={
                    x
                }
                y={
                    y
                }
                width={
                    w
                }
                height={
                    h
                }
                rx={
                    6
                }
                fill="#7B4A2A"
            />


            {
                range(
                    cols
                )
                    .map(
                        columna =>

                            range(
                                rows
                            )
                                .map(
                                    fila => {

                                        const sx =
                                            x +
                                            columna *
                                            cw +
                                            4;

                                        const sy =
                                            y +
                                            fila *
                                            ch +
                                            4;

                                        const sw =
                                            cw -
                                            8;

                                        const sh =
                                            ch -
                                            8;


                                        return (

                                            <g
                                                key={
                                                    `${columna}-${fila}`
                                                }
                                            >

                                                <rect
                                                    x={
                                                        sx
                                                    }
                                                    y={
                                                        sy
                                                    }
                                                    width={
                                                        sw
                                                    }
                                                    height={
                                                        sh
                                                    }
                                                    rx={
                                                        3
                                                    }
                                                    fill="#94592F"
                                                />


                                                <path
                                                    d={
                                                        `M${sx + 2} ${sy + sh - 2}
                                                         L${sx + 2} ${sy + 2}
                                                         L${sx + sw - 2} ${sy + 2}`
                                                    }
                                                    fill="none"
                                                    stroke="#B07446"
                                                    strokeWidth={
                                                        2.5
                                                    }
                                                    strokeLinecap="round"
                                                />


                                                <path
                                                    d={
                                                        `M${sx + sw - 2} ${sy + 2}
                                                         L${sx + sw - 2} ${sy + sh - 2}
                                                         L${sx + 2} ${sy + sh - 2}`
                                                    }
                                                    fill="none"
                                                    stroke="#5A3420"
                                                    strokeWidth={
                                                        2.5
                                                    }
                                                    strokeLinecap="round"
                                                />

                                            </g>
                                        );
                                    }
                                )
                    )
            }

        </g>
    );
};


const CW = 480;
const CH = 150;


// ============================================================================
// CHOCOLATE ENTERO
// ============================================================================

const ChocolateEntero = ({
    n,
    puestos
}) => {

    const width =
        CW /
        n;


    return (

        <svg
            viewBox={
                `0 0 ${CW + 20} ${CH + 20}`
            }
            style={{
                width:
                    480,

                maxWidth:
                    '100%',

                height:
                    'auto',

                display:
                    'block'
            }}
            role="img"
            aria-label="Chocolate para completar"
        >

            <rect
                x={
                    10
                }
                y={
                    10
                }
                width={
                    CW
                }
                height={
                    CH
                }
                rx={
                    8
                }
                fill="#FFFFFF"
                stroke="#9E9E9E"
                strokeWidth={
                    2.5
                }
                strokeDasharray="8 7"
            />


            {
                range(
                    puestos
                )
                    .map(
                        index => (

                            <ColumnaChocolate
                                key={
                                    index
                                }
                                x={
                                    10 +
                                    index *
                                    width +
                                    2
                                }
                                y={
                                    10
                                }
                                w={
                                    width -
                                    4
                                }
                                h={
                                    CH
                                }
                            />
                        )
                    )
            }

        </svg>
    );
};


// ============================================================================
// PEDAZO DE CHOCOLATE
// ============================================================================

const ChocolatePedazo = ({
    n
}) => {

    const width =
        CW /
        n -
        4;


    return (

        <svg
            viewBox={
                `0 0 ${width + 8} ${CH + 8}`
            }
            style={{
                width:
                    Math.min(
                        width +
                        8,
                        220
                    ),

                height:
                    'auto',

                display:
                    'block'
            }}
            role="img"
            aria-label="Un pedazo de chocolate"
        >

            <ColumnaChocolate
                x={
                    4
                }
                y={
                    4
                }
                w={
                    width
                }
                h={
                    CH
                }
            />

        </svg>
    );
};


// ============================================================================
// FRACCIÓN
// ============================================================================

const Fraccion = ({
    num,
    den,
    size = 80,
    color = INK
}) => {

    return (

        <span
            style={{
                display:
                    'inline-flex',

                flexDirection:
                    'column',

                alignItems:
                    'center',

                fontFamily:
                    'Nunito',

                fontWeight:
                    800,

                color,

                lineHeight:
                    1
            }}
        >

            <span
                style={{
                    fontSize:
                        size
                }}
            >
                {num}
            </span>


            <span
                style={{
                    width:
                        size *
                        0.9,

                    height:
                        Math.max(
                            3,
                            size /
                            14
                        ),

                    background:
                        color,

                    borderRadius:
                        2,

                    margin:
                        `${size * 0.08}px 0`
                }}
            />


            <span
                style={{
                    fontSize:
                        size
                }}
            >
                {den}
            </span>

        </span>
    );
};


// ============================================================================
// BOTONES
// ============================================================================

const boton = {

    fontFamily:
        'Nunito',

    fontSize:
        17,

    fontWeight:
        600,

    padding:
        '8px 16px',

    borderRadius:
        12,

    border:
        `2px solid ${ACCENT}`,

    background:
        '#FFFFFF',

    color:
        ACCENT,

    cursor:
        'pointer'
};


const botonPequeno = {

    ...boton,

    padding:
        '4px 14px',

    fontSize:
        22,

    lineHeight:
        1
};


// ============================================================================
// CONTADOR
// ============================================================================

const Contador = ({
    valor,
    onCambio,
    min,
    etiqueta,
    disabled
}) => {


    const restar = () => {

        if (
            disabled
        ) {

            return;
        }


        onCambio(

            valor === null

                ? min

                : Math.max(
                    min,
                    valor -
                    1
                )
        );
    };


    const sumar = () => {

        if (
            disabled
        ) {

            return;
        }


        onCambio(

            valor === null

                ? Math.max(
                    min,
                    1
                )

                : Math.min(
                    20,
                    valor +
                    1
                )
        );
    };


    return (

        <div
            style={{
                display:
                    'flex',

                alignItems:
                    'center',

                gap:
                    12
            }}
        >

            <button
                type="button"
                style={{
                    ...botonPequeno,

                    opacity:
                        disabled
                            ? 0.4
                            : 1
                }}
                disabled={
                    disabled
                }
                aria-label={
                    `Restar ${etiqueta}`
                }
                onClick={
                    restar
                }
            >
                −
            </button>


            <div
                style={{
                    width:
                        56,

                    height:
                        56,

                    border:
                        `3px solid ${INK}`,

                    borderRadius:
                        10,

                    display:
                        'flex',

                    alignItems:
                        'center',

                    justifyContent:
                        'center',

                    fontFamily:
                        'Nunito',

                    fontSize:
                        30,

                    fontWeight:
                        700,

                    color:
                        valor === null

                            ? '#AAAAAA'
                            : INK
                }}
            >
                {
                    valor === null
                        ? '?'
                        : valor
                }
            </div>


            <button
                type="button"
                style={{
                    ...botonPequeno,

                    opacity:
                        disabled
                            ? 0.4
                            : 1
                }}
                disabled={
                    disabled
                }
                aria-label={
                    `Sumar ${etiqueta}`
                }
                onClick={
                    sumar
                }
            >
                +
            </button>

        </div>
    );
};


// ============================================================================
// RECTA
// ============================================================================

const RW = 900;
const RX = 60;
const RL = 3;

const RU =
    (
        RW -
        2 *
        RX
    ) /
    RL;

const RY = 130;


const Recta = ({
    n,
    tiritas,
    completo,
    mark,
    onMarcar
}) => {

    const width =
        RU /
        n;


    const clic = (
        e
    ) => {

        if (
            completo
        ) {

            return;
        }


        const svg =
            e.currentTarget
                .ownerSVGElement;


        if (
            !svg
        ) {

            return;
        }


        const pt =
            svg.createSVGPoint();


        pt.x =
            e.clientX;

        pt.y =
            e.clientY;


        const matrix =
            svg.getScreenCTM();


        if (
            !matrix
        ) {

            return;
        }


        const local =
            pt.matrixTransform(
                matrix.inverse()
            );


        let valor =
            Math.max(
                0,
                Math.min(
                    RL,
                    (
                        local.x -
                        RX
                    ) /
                    RU
                )
            );


        const candidatos = [

            ...range(
                RL +
                1
            ),

            ...range(
                tiritas +
                1
            )
                .map(
                    index =>
                        index /
                        n
                )

        ];


        const cerca =
            candidatos.reduce(
                (
                    actual,
                    candidato
                ) =>

                    Math.abs(
                        candidato -
                        valor
                    ) <
                    Math.abs(
                        actual -
                        valor
                    )

                        ? candidato
                        : actual,

                candidatos[0]
            );


        if (
            Math.abs(
                cerca -
                valor
            ) *
            RU <
            16
        ) {

            valor =
                cerca;
        }


        onMarcar(
            Math.round(
                valor *
                1000
            ) /
            1000
        );
    };


    return (

        <svg
            viewBox={
                `0 0 ${RW} 200`
            }
            style={{
                width:
                    '100%',

                height:
                    'auto',

                display:
                    'block'
            }}
            role="img"
            aria-label="Recta numérica"
        >

            {/* ============================================================= */}
            {/* TIRITAS                                                       */}
            {/* ============================================================= */}

            {
                range(
                    tiritas
                )
                    .map(
                        index => (

                            <g
                                key={
                                    index
                                }
                            >

                                <rect
                                    x={
                                        RX +
                                        index *
                                        width
                                    }
                                    y={
                                        RY -
                                        58
                                    }
                                    width={
                                        width
                                    }
                                    height={
                                        42
                                    }
                                    fill={
                                        TIRA[
                                            index %
                                            TIRA.length
                                        ]
                                    }
                                    stroke="#333333"
                                    strokeWidth={
                                        2
                                    }
                                />


                                {
                                    width > 34 && (

                                        <text
                                            x={
                                                RX +
                                                index *
                                                width +
                                                width /
                                                2
                                            }
                                            y={
                                                RY -
                                                31
                                            }
                                            textAnchor="middle"
                                            fontSize={
                                                width > 60
                                                    ? 17
                                                    : 13
                                            }
                                            fontWeight="700"
                                            fill={
                                                INK
                                            }
                                        >
                                            {`1/${n}`}
                                        </text>
                                    )
                                }

                            </g>
                        )
                    )
            }


            {/* ============================================================= */}
            {/* LÍNEA                                                         */}
            {/* ============================================================= */}

            <line
                x1={
                    RX -
                    40
                }
                y1={
                    RY
                }
                x2={
                    RW -
                    20
                }
                y2={
                    RY
                }
                stroke={
                    INK
                }
                strokeWidth={
                    3
                }
            />


            <polygon
                points={
                    `${RX - 52},${RY} ${RX - 38},${RY - 8} ${RX - 38},${RY + 8}`
                }
                fill={
                    INK
                }
            />


            <polygon
                points={
                    `${RW - 8},${RY} ${RW - 22},${RY - 8} ${RW - 22},${RY + 8}`
                }
                fill={
                    INK
                }
            />


            {
                range(
                    RL +
                    1
                )
                    .map(
                        numero => (

                            <g
                                key={
                                    numero
                                }
                            >

                                <line
                                    x1={
                                        RX +
                                        numero *
                                        RU
                                    }
                                    y1={
                                        RY -
                                        12
                                    }
                                    x2={
                                        RX +
                                        numero *
                                        RU
                                    }
                                    y2={
                                        RY +
                                        12
                                    }
                                    stroke={
                                        INK
                                    }
                                    strokeWidth={
                                        3
                                    }
                                />


                                <text
                                    x={
                                        RX +
                                        numero *
                                        RU
                                    }
                                    y={
                                        RY +
                                        40
                                    }
                                    textAnchor="middle"
                                    fontSize="22"
                                    fontWeight="700"
                                    fill={
                                        INK
                                    }
                                >
                                    {numero}
                                </text>

                            </g>
                        )
                    )
            }


            <rect
                x={
                    RX -
                    20
                }
                y={
                    RY -
                    16
                }
                width={
                    RL *
                    RU +
                    40
                }
                height={
                    64
                }
                fill="transparent"
                style={{
                    cursor:
                        completo
                            ? 'default'
                            : 'pointer'
                }}
                onClick={
                    clic
                }
            />


            {
                mark !== null && (

                    <g
                        pointerEvents="none"
                    >

                        <circle
                            cx={
                                RX +
                                mark *
                                RU
                            }
                            cy={
                                RY
                            }
                            r={
                                10
                            }
                            fill={
                                completo
                                    ? OK
                                    : MARK
                            }
                            stroke="#FFFFFF"
                            strokeWidth={
                                2
                            }
                        />


                        {
                            completo && (

                                <text
                                    x={
                                        RX +
                                        mark *
                                        RU
                                    }
                                    y={
                                        RY +
                                        42
                                    }
                                    textAnchor="middle"
                                    fontSize="28"
                                    fontWeight="800"
                                    fill={
                                        OK
                                    }
                                >
                                    1
                                </text>
                            )
                        }

                    </g>
                )
            }

        </svg>
    );
};


// ============================================================================
// ESTADO INICIAL
// ============================================================================

const estadoInicial = () => ({

    etapa:
        0,

    hecho:
        false,

    puestos:
        0,

    num:
        null,

    den:
        null,

    tiritas:
        0,

    mark:
        null
});


// ============================================================================
// M157
// ============================================================================

const M157 = () => {


    const dispatch =
        useDispatch();


    const navigate =
        useNavigate();


    const [config] =
        useConfigAuth();


    // =========================================================================
    // REDUX
    // =========================================================================

    const iniciar =
        useSelector(
            state =>
                state.ejercicio.iniciar
        );


    const finalizar =
        useSelector(
            state =>
                state.ejercicio.finalizar
        );


    const id_paciente =
        useSelector(
            state =>
                state.usuario.id_paciente
        );


    const sesion =
        useSelector(
            state =>
                state.ejercicio.sesion
        );


    // =========================================================================
    // EJERCICIOS
    // =========================================================================

    const [
        ejercicios,
        setEjercicios
    ] = useState([]);


    const [
        count,
        setCount
    ] = useState(0);


    const [
        st,
        setSt
    ] = useState(
        estadoInicial
    );


    // =========================================================================
    // FEEDBACK
    // =========================================================================

    const [
        feedback,
        setFeedback
    ] = useState(null);


    const [
        disable,
        setDisable
    ] = useState(false);


    const [
        isCorrect,
        setIsCorrect
    ] = useState(false);


    const [
        isIncorrect,
        setIsIncorrect
    ] = useState(false);


    // =========================================================================
    // ERRORES
    // =========================================================================

    const [
        contarErrores,
        setContarErrores
    ] = useState(0);


    const [
        erroresItemActual,
        setErroresItemActual
    ] = useState(0);


    const [
        erroresOrden,
        setErroresOrden
    ] = useState([]);


    // =========================================================================
    // ESTÍMULOS
    // =========================================================================

    const [
        respuestasOrden,
        setRespuestasOrden
    ] = useState([]);


    // =========================================================================
    // ACTUAL
    // =========================================================================

    const ejercicioActual =
        ejercicios.length > 0

            ? ejercicios[
                count
            ]

            : null;


    const tipo =
        ejercicioActual
            ? ejercicioActual.tipo
            : 'pizza';


    const n =
        ejercicioActual
            ? ejercicioActual.n
            : 1;


    const cosa =
        NOMBRE[
            tipo
        ];


    const activo =
        !disable &&
        !st.hecho;


    // =========================================================================
    // TEXTO GUARDADO
    //
    // P:1/4
    // C:1/6
    //
    // Entra cómodo en VARCHAR(10).
    // =========================================================================

    const textoEstimulo = () => {

        const letra =
            tipo === 'pizza'
                ? 'P'
                : 'C';


        return (
            `${letra}:1/${n}`
        );
    };


    // =========================================================================
    // SONIDOS
    // =========================================================================

    const GoodWork = () => {

        new Audio(
            '/sounds/sonido_bien.mp3'
        ).play();
    };


    const TryAgain = () => {

        new Audio(
            '/sounds/sonidoMal.mp3'
        ).play();
    };


    // =========================================================================
    // SET
    // =========================================================================

    const actualizar = (
        cambios
    ) => {

        setSt(
            anterior => ({

                ...anterior,

                ...(
                    typeof cambios === 'function'

                        ? cambios(
                            anterior
                        )

                        : cambios
                )
            })
        );


        setFeedback(
            null
        );
    };


    // =========================================================================
    // ERROR
    // =========================================================================

    const marcarError = (
        texto
    ) => {

        setContarErrores(
            errores =>
                errores +
                1
        );


        setErroresItemActual(
            errores =>
                errores +
                1
        );


        setFeedback({

            ok:
                false,

            text:
                texto
        });


        setDisable(
            true
        );


        setIsIncorrect(
            true
        );


        TryAgain();


        setTimeout(() => {

            setIsIncorrect(
                false
            );


            setDisable(
                false
            );

        }, 300);
    };


    // =========================================================================
    // CORRECTO
    // =========================================================================

    const etapaCorrecta = (
        texto
    ) => {

        const etapaActual =
            st.etapa;


        setDisable(
            true
        );


        setIsCorrect(
            true
        );


        setSt(
            anterior => ({

                ...anterior,

                hecho:
                    true
            })
        );


        setFeedback({

            ok:
                true,

            text:
                texto
        });


        GoodWork();


        setTimeout(() => {


            setIsCorrect(
                false
            );


            // =================================================================
            // SIGUIENTE ETAPA
            // =================================================================

            if (
                etapaActual <
                2
            ) {

                setSt(
                    anterior => ({

                        ...anterior,

                        etapa:
                            etapaActual +
                            1,

                        hecho:
                            false
                    })
                );


                setFeedback(
                    null
                );


                setDisable(
                    false
                );


                return;
            }


            // =================================================================
            // TERMINÓ EL ESTÍMULO
            // =================================================================

            const nuevaLista = [

                ...respuestasOrden,

                textoEstimulo()

            ];


            const nuevosErrores = [

                ...erroresOrden,

                erroresItemActual

            ];


            setRespuestasOrden(
                nuevaLista
            );


            setErroresOrden(
                nuevosErrores
            );


            // =================================================================
            // SIGUIENTE
            // =================================================================

            if (
                count <
                ejercicios.length -
                1
            ) {

                setCount(
                    anterior =>
                        anterior +
                        1
                );


                setSt(
                    estadoInicial()
                );


                setErroresItemActual(
                    0
                );


                setFeedback(
                    null
                );


                setDisable(
                    false
                );


                return;
            }


            // =================================================================
            // FIN
            // =================================================================

            setFeedback(
                null
            );


            setTimeout(() => {

                dispatch(
                    finalizarEjercicioAction()
                );

            }, 50);


        }, 300);
    };


    // =========================================================================
    // COMPROBAR
    // =========================================================================

    const comprobar = () => {

        if (
            disable ||
            st.hecho ||
            !ejercicioActual
        ) {

            return;
        }


        // =====================================================================
        // ETAPA 1
        // COMPLETAR EL ENTERO
        // =====================================================================

        if (
            st.etapa === 0
        ) {

            if (
                st.puestos <
                n
            ) {

                marcarError(
                    `Todavía no completaste ${cosa}. Agregá más pedazos.`
                );

                return;
            }


            etapaCorrecta(
                `¡Muy bien! Para completar ${cosa} se necesitan ${n} pedazos.`
            );


            return;
        }


        // =====================================================================
        // ETAPA 2
        // ESCRIBIR n/n
        // =====================================================================

        if (
            st.etapa === 1
        ) {

            if (
                st.num === null ||
                st.den === null
            ) {

                marcarError(
                    'Completá los dos números.'
                );

                return;
            }


            if (
                st.num === n &&
                st.den === n
            ) {

                etapaCorrecta(
                    `¡Muy bien! ${n} pedazos de 1/${n} forman el entero: ${n}/${n}.`
                );


                return;
            }


            if (
                st.den !== n
            ) {

                marcarError(
                    `Cada pedazo es 1/${n}. El número de abajo indica en cuántas partes iguales está dividido el entero.`
                );


                return;
            }


            marcarError(
                `Contá cuántos pedazos de 1/${n} necesitaste para completar ${cosa}.`
            );


            return;
        }


        // =====================================================================
        // ETAPA 3
        // RECTA
        //
        // IMPORTANTE:
        // EXIGIMOS EXACTAMENTE n TIRITAS + MARCAR EL 1.
        // =====================================================================

        if (
            st.tiritas <
            n
        ) {

            marcarError(
                `Todavía faltan tiritas. ¿Cuántas de 1/${n} necesitás para formar un entero?`
            );


            return;
        }


        if (
            st.tiritas >
            n
        ) {

            marcarError(
                `Hay tiritas de más. Para formar un entero necesitás exactamente ${n}.`
            );


            return;
        }


        if (
            st.mark === null
        ) {

            marcarError(
                'Ahora tocá en la recta dónde está el 1.'
            );


            return;
        }


        if (
            Math.abs(
                st.mark -
                1
            ) <
            0.02
        ) {

            etapaCorrecta(
                `¡Excelente! ${n} tiritas de 1/${n} forman un entero.`
            );


            return;
        }


        marcarError(
            'Mirá dónde terminan las tiritas. ¿Qué número de la recta está ahí?'
        );
    };


    // =========================================================================
    // PLAY
    // =========================================================================

    const verificar = (
        e
    ) => {

        e.preventDefault();


        if (
            disable ||
            st.hecho
        ) {

            return;
        }


        comprobar();
    };


    // =========================================================================
    // INICIALIZAR
    // =========================================================================

    useEffect(() => {

        const seleccion =
            seleccionarEjercicios();


        setEjercicios(
            seleccion
        );


        setCount(
            0
        );


        setSt(
            estadoInicial()
        );


        dispatch(
            setearEjercicioAction(
                'M157'
            )
        );


        dispatch(
            setearUrlAnteriorAction(
                'matematica/fracciones/'
            )
        );


        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    // =========================================================================
    // GUARDAR
    // =========================================================================

    useEffect(() => {

        if (
            !finalizar
        ) {

            return;
        }


        const informacion = {

            config,

            payload: {

                ejercicio:
                    'M157',

                errores:
                    contarErrores,

                lista_usada:
                    respuestasOrden,

                erroresOrden,

                id_paciente,

                sesion
            }
        };


        dispatch(
            almacenarAction(
                informacion
            )
        );


        navigate(
            '/escritorio/metodos/finalizar-ejercicio'
        );


        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [finalizar]);


    // =========================================================================
    // INSTRUCCIONES
    // =========================================================================

    if (
        !iniciar
    ) {

        return (

            <Fragment>

                <HeaderEjercicios
                    estrellas={
                        true
                    }
                    carrito={
                        true
                    }
                    minMay={
                        false
                    }
                />


                <Instrucciones
                    miniInstrucciones={
                        miniInstrucciones
                    }
                />

            </Fragment>
        );
    }


    if (
        !ejercicioActual
    ) {

        return null;
    }


    // =========================================================================
    // PEDAZO
    // =========================================================================

    const Pedazo =
        tipo === 'pizza'

            ? (
                <PizzaPedazo
                    n={
                        n
                    }
                />
            )

            : (
                <ChocolatePedazo
                    n={
                        n
                    }
                />
            );


    // =========================================================================
    // RENDER
    // =========================================================================

    return (

        <PantallaM157>


            <HeaderEjercicios
                estrellas={
                    true
                }
                carrito={
                    true
                }
                minMay={
                    false
                }
            />


            <ContenidoM157>


                <ContainerFlex
                    height="100%"
                    width="100%"
                    display="flex"
                    direction="column"
                    justify="center"
                    align="center"
                    isCorrect={
                        isCorrect
                    }
                    isIncorrect={
                        isIncorrect
                    }
                    $mantengoMay={
                        true
                    }
                >


                    <ZonaTrabajoM157>


                        {/* ================================================= */}
                        {/* IZQUIERDA                                         */}
                        {/* ================================================= */}

                        <EjemploM157>


                            {
                                st.etapa <
                                2

                                    ? Pedazo

                                    : (

                                        <svg
                                            viewBox="0 0 120 50"
                                            style={{
                                                width:
                                                    140,

                                                height:
                                                    'auto'
                                            }}
                                            aria-hidden="true"
                                        >

                                            <rect
                                                x={
                                                    4
                                                }
                                                y={
                                                    4
                                                }
                                                width={
                                                    112
                                                }
                                                height={
                                                    42
                                                }
                                                fill={
                                                    TIRA[0]
                                                }
                                                stroke="#333333"
                                                strokeWidth={
                                                    2.5
                                                }
                                            />

                                        </svg>
                                    )
                            }


                            {
                                st.etapa ===
                                0

                                    ? (

                                        <span
                                            className="texto-pedazo-m157"
                                        >
                                            1 pedazo
                                        </span>
                                    )

                                    : (

                                        <Fraccion
                                            num={
                                                1
                                            }
                                            den={
                                                n
                                            }
                                            size={
                                                62
                                            }
                                        />
                                    )
                            }


                        </EjemploM157>


                        {/* ================================================= */}
                        {/* DERECHA                                           */}
                        {/* ================================================= */}

                        <ActividadM157>


                            {/* ============================================= */}
                            {/* ETAPA 1                                       */}
                            {/* ============================================= */}

                            {
                                st.etapa === 0 && (

                                    <>

                                        <p
                                            className="consigna-m157"
                                        >
                                            Esto es un pedazo de {tipo}.
                                            <br />
                                            ¿Cuántos pedazos necesitás para completar {cosa}?
                                        </p>


                                        <EscenaM157>


                                            {
                                                tipo === 'pizza'

                                                    ? (

                                                        <PizzaEntera
                                                            n={
                                                                n
                                                            }
                                                            puestos={
                                                                st.puestos
                                                            }
                                                        />
                                                    )

                                                    : (

                                                        <ChocolateEntero
                                                            n={
                                                                n
                                                            }
                                                            puestos={
                                                                st.puestos
                                                            }
                                                        />
                                                    )
                                            }


                                        </EscenaM157>


                                        <div
                                            className="botones-m157"
                                        >

                                            <button
                                                type="button"
                                                style={{
                                                    ...boton,

                                                    opacity:
                                                        !activo ||
                                                        st.puestos >= n

                                                            ? 0.4
                                                            : 1
                                                }}
                                                disabled={
                                                    !activo ||
                                                    st.puestos >= n
                                                }
                                                onClick={() =>
                                                    actualizar(
                                                        anterior => ({

                                                            puestos:
                                                                Math.min(
                                                                    n,
                                                                    anterior.puestos +
                                                                    1
                                                                )
                                                        })
                                                    )
                                                }
                                            >
                                                Agregar pedazo
                                            </button>


                                            {
                                                st.puestos > 0 && (

                                                    <button
                                                        type="button"
                                                        style={{
                                                            ...boton,

                                                            borderColor:
                                                                MARK,

                                                            color:
                                                                MARK,

                                                            opacity:
                                                                !activo
                                                                    ? 0.4
                                                                    : 1
                                                        }}
                                                        disabled={
                                                            !activo
                                                        }
                                                        onClick={() =>
                                                            actualizar(
                                                                anterior => ({

                                                                    puestos:
                                                                        Math.max(
                                                                            0,
                                                                            anterior.puestos -
                                                                            1
                                                                        )
                                                                })
                                                            )
                                                        }
                                                    >
                                                        Sacar pedazo
                                                    </button>
                                                )
                                            }

                                        </div>

                                    </>
                                )
                            }


                            {/* ============================================= */}
                            {/* ETAPA 2                                       */}
                            {/* ============================================= */}

                            {
                                st.etapa === 1 && (

                                    <>

                                        <p
                                            className="consigna-m157"
                                        >
                                            Cada pedazo es 1/{n}.
                                            <br />
                                            ¿Cómo se escribe el entero completo como fracción?
                                        </p>


                                        <div
                                            className="entero-fraccion-m157"
                                        >

                                            <EscenaM157
                                                $fraccion={
                                                    true
                                                }
                                            >

                                                {
                                                    tipo === 'pizza'

                                                        ? (

                                                            <PizzaEntera
                                                                n={
                                                                    n
                                                                }
                                                                puestos={
                                                                    n
                                                                }
                                                                size={
                                                                    245
                                                                }
                                                            />
                                                        )

                                                        : (

                                                            <ChocolateEntero
                                                                n={
                                                                    n
                                                                }
                                                                puestos={
                                                                    n
                                                                }
                                                            />
                                                        )
                                                }

                                            </EscenaM157>


                                            <span
                                                className="igual-m157"
                                            >
                                                =
                                            </span>


                                            <div
                                                className="respuesta-fraccion-m157"
                                            >

                                                <Contador
                                                    valor={
                                                        st.num
                                                    }
                                                    onCambio={
                                                        valor =>
                                                            actualizar({
                                                                num:
                                                                    valor
                                                            })
                                                    }
                                                    min={
                                                        0
                                                    }
                                                    etiqueta="numerador"
                                                    disabled={
                                                        !activo
                                                    }
                                                />


                                                <div
                                                    className="linea-fraccion-m157"
                                                />


                                                <Contador
                                                    valor={
                                                        st.den
                                                    }
                                                    onCambio={
                                                        valor =>
                                                            actualizar({
                                                                den:
                                                                    valor
                                                            })
                                                    }
                                                    min={
                                                        1
                                                    }
                                                    etiqueta="denominador"
                                                    disabled={
                                                        !activo
                                                    }
                                                />

                                            </div>


                                        </div>

                                    </>
                                )
                            }


                            {/* ============================================= */}
                            {/* ETAPA 3                                       */}
                            {/* ============================================= */}

                            {
                                st.etapa === 2 && (

                                    <>

                                        <p
                                            className="consigna-m157"
                                        >
                                            Agregá tiritas de 1/{n} hasta formar un entero y marcá el 1.
                                        </p>


                                        <EscenaM157
                                            $recta={
                                                true
                                            }
                                        >

                                            <Recta
                                                n={
                                                    n
                                                }
                                                tiritas={
                                                    st.tiritas
                                                }
                                                completo={
                                                    st.hecho ||
                                                    disable
                                                }
                                                mark={
                                                    st.mark
                                                }
                                                onMarcar={
                                                    valor =>
                                                        actualizar({
                                                            mark:
                                                                valor
                                                        })
                                                }
                                            />

                                        </EscenaM157>


                                        <div
                                            className="botones-m157"
                                        >

                                            <button
                                                type="button"
                                                style={{
                                                    ...boton,

                                                    opacity:
                                                        !activo
                                                            ? 0.4
                                                            : 1
                                                }}
                                                disabled={
                                                    !activo
                                                }
                                                onClick={() =>
                                                    actualizar(
                                                        anterior => ({

                                                            tiritas:
                                                                Math.min(
                                                                    3 *
                                                                    n,
                                                                    anterior.tiritas +
                                                                    1
                                                                )
                                                        })
                                                    )
                                                }
                                            >
                                                Agregar tirita
                                            </button>


                                            {
                                                st.tiritas > 0 && (

                                                    <button
                                                        type="button"
                                                        style={{
                                                            ...boton,

                                                            borderColor:
                                                                MARK,

                                                            color:
                                                                MARK,

                                                            opacity:
                                                                !activo
                                                                    ? 0.4
                                                                    : 1
                                                        }}
                                                        disabled={
                                                            !activo
                                                        }
                                                        onClick={() =>
                                                            actualizar(
                                                                anterior => ({

                                                                    tiritas:
                                                                        Math.max(
                                                                            0,
                                                                            anterior.tiritas -
                                                                            1
                                                                        )
                                                                })
                                                            )
                                                        }
                                                    >
                                                        Sacar tirita
                                                    </button>
                                                )
                                            }

                                        </div>

                                    </>
                                )
                            }


                            {/* ============================================= */}
                            {/* FEEDBACK                                      */}
                            {/* ============================================= */}

                            <p
                                className={
                                    feedback

                                        ? feedback.ok

                                            ? 'feedback-m157 ok'
                                            : 'feedback-m157 error'

                                        : 'feedback-m157'
                                }
                            >
                                {
                                    feedback
                                        ? feedback.text
                                        : '.'
                                }
                            </p>


                        </ActividadM157>


                    </ZonaTrabajoM157>


                </ContainerFlex>


            </ContenidoM157>


            <BottomM157>


                <BotoneraBottom
                    miniInstrucciones={
                        miniInstrucciones
                    }
                />


                <AvanzarBtn
                    disabled={
                        disable ||
                        st.hecho
                    }
                    onClick={
                        verificar
                    }
                >

                    <AvanzarImg
                        src="/img/play.png"
                    />

                </AvanzarBtn>


            </BottomM157>


        </PantallaM157>
    );
};


export default M157;